import { clearCandidateSession } from "../../auth/candidateSession";

const BASE = process.env.REACT_APP_SITE_URL || "";

export default async function sessionInterceptor(response: Response) {
  if (response.status === 401) {
    clearCandidateSession();
    window.location.replace(`${BASE}/login`);
    return;
  }
}
